import { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { environment } from '../config/environment.ts';
import React from 'react';

interface Auth0ProviderWithHistoryProps {
  children: ReactNode;
}

const Auth0ProviderWithHistory = ({ children }: Auth0ProviderWithHistoryProps) => {
  const redirectUri = window.location.origin;
  return (
    <Auth0Provider
      domain={environment.auth0.domain}
      clientId={environment.auth0.clientId}
      authorizationParams={{
        redirect_uri:redirectUri,
        scope: environment.auth0.authorizationParams.scope,
        // audience: environment.auth0.audience,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
